import { Action, combineReducers } from "redux";
import { ICalendarTaskPage } from "source/models/calendarTask/calendarTaskPage";

// State
export interface ICalendarTaskPageState {
    dataId: number;
    calendarTaskPage: ICalendarTaskPage;
}

export interface ICalendarTaskState {
    page: ICalendarTaskPageState;
}

// Action type constants
const CALENDARTASK_SUCCESS = "CALENDARTASK_SUCCESS";
const CALENDARTASK_FAILURE = "CALENDARTASK_FAILURE";

type T_CALENDARTASK_SUCCESS = typeof CALENDARTASK_SUCCESS;
type T_CALENDARTASK_FAILURE = typeof CALENDARTASK_FAILURE;

// Action types
interface ICalendarTaskSuccess extends Action {
    type: T_CALENDARTASK_SUCCESS;
    calendarTaskPage: ICalendarTaskPage;
}

interface ICalendarTaskFailure extends Action {
    type: T_CALENDARTASK_FAILURE;
}

export type CalendarTaskAction =
    | ICalendarTaskSuccess
    | ICalendarTaskFailure;

//Actions
export const calendarTaskSuccess = (calendarTaskPage: ICalendarTaskPage): ICalendarTaskSuccess => ({
    type: CALENDARTASK_SUCCESS,
    calendarTaskPage
});

export const calendarTaskFailure = (): ICalendarTaskFailure => ({
    type: CALENDARTASK_FAILURE
});

//Reducers
export const calendarTaskInitialState: ICalendarTaskState = {
    page: {
        dataId: 0,
        calendarTaskPage: null
    }
};

const page = (state: ICalendarTaskPageState = null, action: CalendarTaskAction) => {
    switch (action.type) {
    case CALENDARTASK_SUCCESS: {
        const calendarTaskSuccess = action as ICalendarTaskSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            calendarTaskPage: calendarTaskSuccess.calendarTaskPage
        };
    }
    case CALENDARTASK_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const calendarTaskReducer = combineReducers({
    page
});

//Utils